import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminMenuComponent } from '../../admin-menu/feature/admin-menu.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-admin-boilerplate',
  imports: [AdminMenuComponent],
  templateUrl: '../ui/admin-boilerplate.component.html',
  styleUrl: '../ui/admin-boilerplate.component.css'
})
export class AdminBoilerplateComponent implements OnInit {
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _titleService = inject(Title);
  displaySidepanel: boolean = this._activatedRoute.snapshot.data.hasOwnProperty("sidebar")? this._activatedRoute.snapshot.data.hasOwnProperty("sidebar").valueOf() : true;

  ngOnInit(): void {
    this._titleService.setTitle("LRPTickets.co.uk | Admin")
  }
}
